export const BLOG_ARTICLES_PER_PAGE = 10
